import { Directive, OnDestroy, OnInit } from '@angular/core';
import { DatatableComponent } from '@app/datatables/models/custom-datatable-extension';
import { PageChangeEvent } from '@app/shared/components/pagination/page-change-event';
import { Page } from '@app/shared/models/page';
import { ApiPageInfo } from 'datatables.net';

@Directive()
export abstract class DatatablePagination extends DatatableComponent implements OnDestroy, OnInit {
  public page!: Page;

  get filtered() {
    return this.pageInfo.recordsDisplay;
  }

  get pageNumber() {
    return this.pageInfo.page + 1;
  }

  get pageSize() {
    return this.pageInfo.length;
  }

  get pages() {
    return Math.floor(this.total / this.pageSize);
  }

  get selectionCount() {
    return this.datatablePage.dtOptions.select !== false ? this.datatablePage.selectedEntries.length : null;
  }

  get total() {
    return this.pageInfo.recordsTotal;
  }

  private drawCallback = () => {
    this.updatePage();
  };

  private pageInfo!: ApiPageInfo;

  public ngOnDestroy() {
    this.dtInstance.off('draw', this.drawCallback);
  }

  public ngOnInit() {
    this.dtInstance.on('draw', this.drawCallback);

    this.updatePage();
  }

  public onPageChanged($event: PageChangeEvent) {
    const currentPage = this.dtInstance.page.info();

    if (currentPage.length !== $event.pageSize || currentPage.page !== $event.page - 1) {
      this.dtInstance
        .page($event.page - 1)
        .page.len($event.pageSize)
        .draw('page');
    }
  }

  public updatePage(): void {
    this.pageInfo = this.dtInstance.page.info();

    const from = (this.pageNumber - 1) * this.pageSize;
    const to = from + this.pageSize;

    this.page = {
      allEntries: [],
      filteredEntries: [],
      filtered: this.filtered,
      from: from + 1,
      entries: [],
      page: this.pageNumber,
      pageSize: this.pageSize,
      pages: this.pages,
      to: to > this.filtered ? this.filtered : to,
      total: this.total,
    };
  }
}
